<div class="cus-snakebar">
    <mat-icon>{{getIcon}}</mat-icon>{{ '&nbsp;' | translate }}<span>{{ data?.message }}</span>
    <div class="spacer"></div>
    <button mat-button (click)="closeSnackbar()" >
        {{data.action}}
    </button>
</div>